import { OwnerReason } from 'api/resources/models/AutoGenerated';
import { GrayBackdrop, Loader } from 'components/Loader';
import { Modal } from 'components/Modal';
import { useOwnerContact } from 'pages/hooks';
import { useState } from 'react';
import { ContactOwner } from './ContactOwner';
import { ownerReasons } from './mappings';
import { ReasonsForm } from './ReasonsForm';

interface ContactOwnerModalProps {
  isOpen: boolean;
  onClose: () => void;
  repairId: number;
}

type ModalStep = 'OwnerInformation' | 'ReasonsForm';

export function ContactOwnerModal({
  isOpen,
  onClose,
  repairId,
}: ContactOwnerModalProps) {
  const [currentStep, setCurrentStep] = useState<ModalStep>('ReasonsForm');

  const ownerContact = useOwnerContact();

  const title =
    currentStep === 'OwnerInformation'
      ? 'Contact Owner'
      : 'Personally Identifiable Information';
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onClose={currentStep === 'OwnerInformation' ? undefined : onClose}
      onExited={() => setCurrentStep('ReasonsForm')}
    >
      <GrayBackdrop open={ownerContact.isRecording}>
        <Loader />
      </GrayBackdrop>
      {currentStep === 'OwnerInformation' ? (
        <ContactOwner repairId={repairId} onContinue={onClose} />
      ) : (
        <ReasonsForm<OwnerReason>
          reasons={ownerReasons}
          defaultReason={OwnerReason.Other}
          onSubmit={onSubmit}
          type={'owner'}
        />
      )}
    </Modal>
  );

  function onSubmit(
    selectedReason: OwnerReason,
    additionalNotes: string | null
  ) {
    ownerContact
      .record(repairId, selectedReason, additionalNotes)
      .then(() => setCurrentStep('OwnerInformation'));
  }
}
